import { render, staticRenderFns } from "./SmsPattern.vue?vue&type=template&id=1bcb6b94&scoped=true"
import script from "./SmsPattern.vue?vue&type=script&lang=js"
export * from "./SmsPattern.vue?vue&type=script&lang=js"
import style0 from "./SmsPattern.vue?vue&type=style&index=0&id=1bcb6b94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcb6b94",
  null
  
)

export default component.exports